import {NavigateFunction} from 'react-router-dom';
import {savaquanFetch, savaquanFetchJson} from '../../shared/services/http.service';
import {
  PermissionCatalogItem,
  RbacCompanyUserDto,
  RbacGroupDto,
  RbacRoleDto,
} from '../../shared/permissions/permissions';

const baseUrl = `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/rbac`;

export const getRbacPermissions = (navigate: NavigateFunction) =>
  savaquanFetchJson<PermissionCatalogItem[]>(`${baseUrl}/permissions`, {navigate});

export const getRbacRoles = (navigate: NavigateFunction) =>
  savaquanFetchJson<RbacRoleDto[]>(`${baseUrl}/roles`, {navigate});

export const setRbacRolePermissions = (
  navigate: NavigateFunction,
  roleId: number,
  permissionCodes: string[],
) =>
  savaquanFetchJson<RbacRoleDto>(`${baseUrl}/roles/${roleId}/permissions`, {
    navigate,
    method: 'PUT',
    body: JSON.stringify({permissionCodes}),
  });

export const getRbacGroups = (navigate: NavigateFunction) =>
  savaquanFetchJson<RbacGroupDto[]>(`${baseUrl}/groups`, {navigate});

export const getRbacUsers = (navigate: NavigateFunction) =>
  savaquanFetchJson<RbacCompanyUserDto[]>(`${baseUrl}/users`, {navigate});

export const setRbacUserGroups = (navigate: NavigateFunction, userId: number, groupIds: number[]) =>
  savaquanFetchJson<RbacCompanyUserDto>(`${baseUrl}/users/${userId}/groups`, {
    navigate,
    method: 'PUT',
    body: JSON.stringify({groupIds}),
  });

export const updateRbacUser = (
  navigate: NavigateFunction,
  userId: number,
  update: {
    name?: string;
    groupIds?: number[];
    phoneNumber?: string | null;
    address?: string | null;
    city?: string | null;
    state?: string | null;
    postalCode?: string | null;
    dateOfBirth?: string | null;
    hireDate?: string | null;
    hourlyPay?: number | null;
    annualSalary?: number | null;
    billableHourlyRate?: number | null;
    hoursWorked?: {startDate?: string | null; days: {day: string; hours: number}[]}[] | null;
  },
) =>
  savaquanFetchJson<RbacCompanyUserDto>(`${baseUrl}/users/${userId}`, {
    navigate,
    method: 'PUT',
    body: JSON.stringify(update),
  });

export const deleteRbacUser = (navigate: NavigateFunction, userId: number) =>
  savaquanFetch(`${baseUrl}/users/${userId}`, {navigate, method: 'DELETE'}).then(() => undefined);

export const setRbacUserActive = (navigate: NavigateFunction, userId: number, active: boolean) =>
  savaquanFetchJson<RbacCompanyUserDto>(`${baseUrl}/users/${userId}/active`, {
    navigate,
    method: 'PUT',
    body: JSON.stringify({active}),
  });
